<template>
  <span>
    <span class="attribute-value">{{ value }}</span>
  </span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    value: String,
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";

.attribute-value {
  color: $attributeValueColor;
  padding: 0;
  margin: 0;
}
</style>
